<template>
  <div class="edit" id="edit"></div>
</template>

<script>
import E from "wangeditor";

export default {
  name: "EditComponents",
  props: {
    content: {
      type: String,
      default: ""
    },
    htmlChange: {
      type: Function,
      default: value => value
    },
    uploadImg: {
      type: Function,
      default: (file, callback) => file
    },
    uploadPath: {
      type: String,
      default: ""
    },
    // domHeight: 300
  },
  data() {
    return {
      editor: undefined,
      text: undefined,
      pasteListener: undefined,
      syncingRemoteImages: false
    };
  },
  mounted() {
    const editor = new E("#edit");
    // const self = this;
    editor.config.onchange = (html) => {
      // this.text = html;
      this?.htmlChange(html);
    };
    editor.config.uploadImgMaxLength = 1; // 每次上传一张
    // editor.config.showLinkImg = false;
    editor.config.customUploadImg = (resultFiles, insertImgFn) => {

      console.log(resultFiles, "resultFiles");
      // resultFiles 是 input 中选中的文件列表
      // insertImgFn 是获取图片 url 后，插入到编辑器的方法

      // 上传图片，返回结果，将图片插入到编辑器中
      this?.uploadImg(resultFiles[0], (imgUrl) => {
        console.log(imgUrl, 'imgUrl');
        insertImgFn(imgUrl);
      }, this.uploadPath);

      // insertImgFn(imgUrl)
    };
    // editor.config.height = this.domHeight;
    this.$nextTick(() => {
      editor.create();
      this.editor = editor;
      this.bindPasteListener();
      if (this.content) {
        editor.txt.html(this.content);
      }
    });

  },
  destroyed() {
    this.unbindPasteListener();
    this.editor?.destroy();
    this.editor = null;
  },
  computed: {
    getContent() {
      const { content, editor } = this;
      if (content && editor) {
        // editor.txt.html(content);
        this.text = content;
      }
      return this.content;
    }
  },
  methods: {
    bindPasteListener() {
      const textElem = this.editor?.$textElem?.elems?.[0];
      if (!textElem) {
        return;
      }
      this.pasteListener = () => {
        window.setTimeout(() => {
          this.syncPastedRemoteImages();
        }, 0);
      };
      textElem.addEventListener("paste", this.pasteListener);
    },
    unbindPasteListener() {
      const textElem = this.editor?.$textElem?.elems?.[0];
      if (textElem && this.pasteListener) {
        textElem.removeEventListener("paste", this.pasteListener);
      }
      this.pasteListener = undefined;
    },
    isRemoteImage(url) {
      if (!url || typeof url !== "string") {
        return false;
      }
      if (url.startsWith("data:") || url.startsWith("blob:")) {
        return false;
      }

      try {
        const parsedUrl = new URL(url, window.location.href);
        if (!["http:", "https:"].includes(parsedUrl.protocol)) {
          return false;
        }
        if (parsedUrl.origin === window.location.origin) {
          return false;
        }
        if (parsedUrl.hostname.includes(".aliyuncs.com")) {
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    async syncPastedRemoteImages() {
      if (this.syncingRemoteImages || !this.editor) {
        return;
      }

      const currentHtml = this.editor.txt.html();
      if (!currentHtml) {
        return;
      }

      const container = document.createElement("div");
      container.innerHTML = currentHtml;
      const imgElements = Array.from(container.querySelectorAll("img[src]"));
      const remoteUrls = [...new Set(imgElements.map((img) => img.getAttribute("src")).filter((url) => this.isRemoteImage(url)))];

      if (!remoteUrls.length) {
        return;
      }

      this.syncingRemoteImages = true;
      let htmlChanged = false;

      try {
        for (let index = 0; index < remoteUrls.length; index += 1) {
          const remoteUrl = remoteUrls[index];
          try {
            const file = await this.fetchRemoteImageAsFile(remoteUrl, index);
            const uploadedUrl = await this.uploadImageFile(file);
            if (!uploadedUrl) {
              continue;
            }
            container.querySelectorAll("img[src]").forEach((img) => {
              if (img.getAttribute("src") === remoteUrl) {
                img.setAttribute("src", uploadedUrl);
              }
            });
            htmlChanged = true;
          } catch (error) {
            console.warn("sync pasted remote image failed", remoteUrl, error);
          }
        }

        if (htmlChanged) {
          const nextHtml = container.innerHTML;
          this.editor.txt.html(nextHtml);
          this.htmlChange(nextHtml);
        }
      } finally {
        this.syncingRemoteImages = false;
      }
    },
    async fetchRemoteImageAsFile(url, index) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`fetch failed: ${response.status}`);
      }

      const blob = await response.blob();
      const parsedUrl = new URL(url, window.location.href);
      const originalName = parsedUrl.pathname.split("/").pop() || `pasted-image-${Date.now()}-${index}`;
      const safeName = decodeURIComponent(originalName).split("?")[0] || `pasted-image-${Date.now()}-${index}`;
      return new File([blob], safeName, {
        type: blob.type || "application/octet-stream"
      });
    },
    uploadImageFile(file) {
      return new Promise((resolve, reject) => {
        try {
          this.uploadImg(
            file,
            (imgUrl) => resolve(imgUrl),
            this.uploadPath
          );
        } catch (error) {
          reject(error);
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
